export const isEmpty = (data) => {
  if (typeof data === 'object') {
    if (Array.isArray(data)) {
      return data.length <= 0
    } else {
      return false
    }
  }
  return !(typeof data === 'string' && data.length > 0)
}

export const validateField = (addressField, data) => {
  if (addressField.isValueRequired && isEmpty(data)) {
    return false
  }
  if (addressField.isRegexRequired && addressField.pattern !== undefined) {
    var regEx = new RegExp(addressField.pattern)
    if (!regEx.test(data)) {
      return false
    }
  }
  return true
}

export const performValidation = (target, addressValidations) => {
  let isValidData = true

  Object.keys(target).forEach((key) => {
    if (
      !(
        key === 'administrativeArea' &&
        (target.countryCode.toUpperCase() === 'GB' ||
          target.countryCode.toUpperCase() === 'FR' ||
          target.countryCode.toUpperCase() === 'CH' ||
          target.countryCode.toUpperCase() === 'AT' ||
          target.countryCode.toUpperCase() === 'NL' ||
          target.countryCode.toUpperCase() === 'PT' ||
          target.countryCode.toUpperCase() === 'PL' ||
          target.countryCode.toUpperCase() === 'DK' ||
          target.countryCode.toUpperCase() === 'IE' ||
          target.countryCode.toUpperCase() === 'BE' ||
          target.countryCode.toUpperCase() === 'DE')
      )
    ) {
      const addressField = addressValidations[key]
      const data = target[key]

      if (addressField) {
        if (typeof data === 'object') {
          Object.keys(addressField).forEach((index) => {
            const dataArr = data[index]
            const addressFieldArr = addressField[index]
            if (!validateField(addressFieldArr, dataArr)) {
              isValidData = false
            }
          })
        } else {
          if (!validateField(addressField, data)) {
            isValidData = false
          }
        }
      }
    }
  })

  return isValidData
}

export const makeShippingAndBillingContactParameters = (
  payment,
  selectedShipModeIdParameter,
  extraParameterCreator
) => {
  let address = ''

  if (extraParameterCreator) {
    address += extraParameterCreator()
  }

  address += `&shipModeId=${selectedShipModeIdParameter}`

  const { shippingContact, billingContact } = payment

  if (!isEmpty(shippingContact)) {
    if (!isEmpty(shippingContact.givenName)) {
      address += '&firstName_s=' + encodeURIComponent(shippingContact.givenName)
    }
    if (!isEmpty(shippingContact.familyName)) {
      address += '&lastName_s=' + encodeURIComponent(shippingContact.familyName)
    }
    if (!isEmpty(shippingContact.locality)) {
      address += '&city_s=' + encodeURIComponent(shippingContact.locality)
    }
    if (!isEmpty(shippingContact.postalCode)) {
      address += '&zipCode_s=' + encodeURIComponent(shippingContact.postalCode)
    }
    if (!isEmpty(shippingContact.addressLines) && !isEmpty(shippingContact.addressLines[0])) {
      address += '&address1_s=' + encodeURIComponent(shippingContact.addressLines[0])
    }
    if (!isEmpty(shippingContact.addressLines) && !isEmpty(shippingContact.addressLines[1])) {
      address += '&address2_s=' + encodeURIComponent(shippingContact.addressLines[1])
    }
    if (!isEmpty(shippingContact.phoneNumber)) {
      address += '&mobilephone1_s=' + shippingContact.phoneNumber
    }
    let state_s = ''
    let country_s = shippingContact.countryCode.toUpperCase()
    if (country_s === 'FR' || country_s === 'CH' || country_s === 'GB' || country_s === 'DE') {
      state_s = country_s
    } else {
      state_s = encodeURIComponent(shippingContact.administrativeArea)
    }
    if (!isEmpty(state_s)) {
      address += '&state_s=' + state_s
    }
    if (!isEmpty(shippingContact.countryCode)) {
      address += '&country_s=' + shippingContact.countryCode.toUpperCase()
    }
    if (!isEmpty(shippingContact.emailAddress)) {
      address += '&email1_s=' + shippingContact.emailAddress
    }
  }
  if (!isEmpty(billingContact)) {
    if (!isEmpty(billingContact.givenName)) {
      address += '&firstName_b=' + encodeURIComponent(billingContact.givenName)
    }
    if (!isEmpty(billingContact.familyName)) {
      address += '&lastName_b=' + encodeURIComponent(billingContact.familyName)
    }
    if (!isEmpty(billingContact.locality)) {
      address += '&city_b=' + encodeURIComponent(billingContact.locality)
    }
    if (!isEmpty(billingContact.postalCode)) {
      address += '&zipCode_b=' + encodeURIComponent(billingContact.postalCode)
    }
    if (!isEmpty(billingContact.addressLines) && !isEmpty(billingContact.addressLines[0])) {
      address += '&address1_b=' + encodeURIComponent(billingContact.addressLines[0])
    }
    if (!isEmpty(billingContact.addressLines) && !isEmpty(billingContact.addressLines[1])) {
      address += '&address2_b=' + encodeURIComponent(billingContact.addressLines[1])
    }
    if (!isEmpty(billingContact.administrativeArea)) {
      address += '&state_b=' + encodeURIComponent(billingContact.administrativeArea)
    }
    if (!isEmpty(billingContact.countryCode)) {
      address += '&country_b=' + billingContact.countryCode.toUpperCase()
    }
    if (!isEmpty(shippingContact.emailAddress)) {
      address += '&email1_b=' + shippingContact.emailAddress
    }
    if (!isEmpty(shippingContact.phoneNumber)) {
      address += '&mobilephone1_b=' + shippingContact.phoneNumber
    }
  }

  return address
}

export const makePaymentTokenParameters = (token) => {
  const { paymentData, paymentMethod } = token

  let paymentToken = '&paymentToken_data=' + encodeURIComponent(paymentData.data)

  paymentToken +=
    '&paymentData_header_publicKeyHash=' + encodeURIComponent(paymentData.header.publicKeyHash)
  paymentToken +=
    '&paymentData_header_ephemeralPublicKey=' +
    encodeURIComponent(paymentData.header.ephemeralPublicKey)
  paymentToken +=
    '&paymentData_header_transactionId=' + encodeURIComponent(paymentData.header.transactionId)
  paymentToken += '&paymentData_signature=' + encodeURIComponent(paymentData.signature)
  paymentToken += '&paymentData_version=' + encodeURIComponent(paymentData.version)
  paymentToken += '&paymentMethod_displayName=' + encodeURIComponent(paymentMethod.displayName)
  paymentToken += '&paymentMethod_network=' + encodeURIComponent(paymentMethod.network)
  paymentToken += '&paymentMethod_type=' + encodeURIComponent(paymentMethod.type)
  paymentToken += '&paymentMethod_paymentPass=' + encodeURIComponent(paymentMethod.paymentPass)
  paymentToken += '&transactionIdentifier=' + encodeURIComponent(token.transactionIdentifier)
  return paymentToken
}

export const makeShippingAddressDetails = (shippingContact) => {
  let address = ''
  if (!isEmpty(shippingContact)) {
    address += '&addressType=S'
    if (!isEmpty(shippingContact.locality)) {
      address += '&city=' + encodeURIComponent(shippingContact.locality)
    }
    if (!isEmpty(shippingContact.postalCode)) {
      address += '&zipCode=' + encodeURIComponent(shippingContact.postalCode)
    }
    let state = ''
    let country = shippingContact.countryCode

    if (country === 'FR' || country === 'CH' || country === 'GB' || country === 'DE') {
      state = country.toUpperCase()
    } else {
      state = encodeURIComponent(shippingContact.administrativeArea)
    }
    if (!isEmpty(state)) {
      address += '&state=' + state
    }
    if (!isEmpty(shippingContact.countryCode)) {
      address += '&country=' + shippingContact.countryCode.toUpperCase()
    }
  }
  return address
}

export const syncAjaxGET = (url, isJson) => {
  const request = new XMLHttpRequest()

  if (isJson) {
    request.setRequestHeader('Accept', 'application/json')
  }

  request.open('GET', url, false)
  request.send(null)

  return request
}

export const syncAjaxPOST = (url, body = null, contentType) => {
  const request = new XMLHttpRequest()
  request.open('POST', url, false)
  if (contentType) {
    request.setRequestHeader('content-type', contentType)
  }
  request.send(body)

  return request
}
